import { Reveal, SectionHeading } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/constants/i18n";

export const Faq = () => {
    const { t } = useLang();
    return (
        <section id="preguntas" data-testid="faq-section" className="bg-ivory py-24 md:py-32">
            <div className="mx-auto max-w-4xl px-5 md:px-10">
                <SectionHeading number="05" eyebrow={t.faq.eyebrow} title={t.faq.title} />
                <Reveal delay={0.15}>
                    <Accordion type="single" collapsible data-testid="faq-accordion">
                        {t.faq.items.map((item, i) => (
                            <AccordionItem
                                key={item.q}
                                value={`faq-${i}`}
                                className="border-b border-gold/25"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-question-${i}`}
                                    className="py-6 text-left font-serif text-xl font-normal text-ink transition-colors duration-300 hover:text-burgundy hover:no-underline md:text-2xl [&[data-state=open]>svg]:text-gold"
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    data-testid={`faq-answer-${i}`}
                                    className="pb-6 text-sm leading-relaxed text-ink/65 md:text-base"
                                >
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
};

export default Faq;
